import SubHeaderContent from '@/components/MobileApproval/SubHeaderContent';
import React, { useEffect, useState } from 'react';
import { useSearchApproval } from '@/hooks/apiHooks';
import ApprovalContents from '@/components/MobileApproval/ApprovalContents';
import useSWRInfinite from 'swr/infinite';
import { Approval, TotalApprovalParams } from '@/types/api';
import { APPROVAL_SEARCH_URL } from '@/constant/approval';
import { approvalSearchListFetcher } from '@/hooks/apiHooks/approval';
import { getApprovalkey, MAX_LIST_SIZE } from '@/components/MobileApproval';
import { rnPermissionDeny, sendBadgeCount } from '@/utils/function';
import Loading from '@/components/MobileApproval/Body/Loading';
import { useAtom, useAtomValue } from 'jotai';
import { approvalState, MyInfoState } from '@/recoil/atom';
import { useTranslation } from 'react-i18next';
import ApprovalSkeleton from '@/components/MobileApproval/ApprovalSkeleton';
import ErrorMessage from '@/components/MobileSales/ErrorMessage';
import { overCountText } from '@/utils';
import { MAX_APPROVAL_LIST_SIZE } from '@/components/Approval';
import { SubHeaderContainer } from '@/components/MobileApproval/Body/styles';
import { ContentLayout } from '@/components/MobileApproval/ApprovalContents/styles';

//결재할 myturn true
//결재한 statues 다 뺴고
//협조결재한 결재 유형 2

type P = {
  showHeader: boolean;
};

const MyApproval = ({ showHeader }: P) => {
  const [isRn, setIsRn] = useState(false);
  const [selectedState, setSelectedState] = useAtom(approvalState);
  const { passportId } = useAtomValue(MyInfoState);

  const idxToStatus = (idx: number): TotalApprovalParams | undefined => {
    switch (idx) {
      case 0:
        return {
          currentApproverPassportIds: [passportId],
          isBookmark: false,
        };
      case 1:
        return {
          approverPassportIds: [passportId],
          approverStatuses: 'C,H,R',
        };
      case 2:
        return {
          coApproverPassportIds: [passportId],
          coApproverStatuses: 'C,H,R',
        };
    }
  };
  useEffect(() => {
    window?.isRNWebview && setIsRn(true);
  }, []);

  const { data: countData, mutate: countMutate } = useSearchApproval(
    {
      listSize: MAX_APPROVAL_LIST_SIZE,
      sortType: 'authoredAt',
      orderType: 'desc',
      currentApproverPassportIds: [passportId],
    },
    {
      refreshInterval: isRn ? 1000 : 0,
      onError: (error, key) => {
        //RN에서는 jwtToken 만료를 정확하게 알수없어서 다음과 같이 세션만료
        if (isRn && error.response?.status === 401) {
          rnPermissionDeny(5);
        }
      },
    },
  );

  useEffect(() => {
    sendBadgeCount({
      tabName: 'approval',
      badgeCount: countData?.meta.totalCount || 0,
    });
  }, [countData]);

  const { data, size, setSize, isLoading, mutate, error } = useSWRInfinite<
    Approval[]
  >(
    getApprovalkey(APPROVAL_SEARCH_URL, {
      listSize: MAX_LIST_SIZE,
      sortType: 'authoredAt',
      orderType: 'desc',
      ...idxToStatus(selectedState.myApprovalKey),
    }),
    approvalSearchListFetcher<Approval>,
    {
      refreshInterval: isRn ? 1000 : 0,
      shouldRetryOnError: false, // 에러 발생 시 재시도를 하지 않도록 설정
      revalidateOnFocus: false,
    },
  );

  const resultData = data?.reduce((prev, next) => prev.concat(next));

  const count = countData?.meta.totalCount || 0;
  const resultCount = overCountText(count);
  const { t } = useTranslation();

  const list: (string | React.ReactNode)[] = [
    <>
      {t('결재할')} <span style={{ fontWeight: 500 }}>{resultCount ?? 0}</span>
    </>,
    t('결재한'),
    t('협조결재한'),
  ];

  const handleClick = (id: number) =>
    setSelectedState({ ...selectedState, myApprovalKey: id });

  const readMoreData = () => {
    setSize(size + 1);
  };

  const isReachingEnd = data && data[data.length - 1]?.length < MAX_LIST_SIZE;
  const handleRefresh = () => mutate();

  return (
    <>
      <SubHeaderContainer showHeader={showHeader}>
        {list.map((res, idx) => (
          <SubHeaderContent
            key={`subHeader-${idx}`}
            id={idx}
            title={res}
            clicked={selectedState.myApprovalKey === idx}
            handleClick={handleClick}
          />
        ))}
      </SubHeaderContainer>
      <ContentLayout haveSubHeader={true}>
        {isLoading ? (
          <>
            {Array.from({ length: 10 }, (_, i) => (
              <ApprovalSkeleton key={`ApprovalSkeleton-${i}`} />
            ))}
          </>
        ) : error ? (
          <ErrorMessage
            errorMessage={error?.response?.data?.message}
            errorCode={error?.response?.data?.status}
            refresh={handleRefresh}
          />
        ) : (
          <ApprovalContents data={resultData} onRefresh={handleRefresh} />
        )}
        {data && !isLoading && !isReachingEnd && (
          <Loading readMoreData={readMoreData} />
        )}
      </ContentLayout>
    </>
  );
};
export default MyApproval;
